import './new-offer-list.scss';
